import React, { useContext, useLayoutEffect, useRef, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import EditIcon from '@material-ui/icons/Edit';
import BorderAllIcon from '@material-ui/icons/BorderAll';
import Tooltip from '@material-ui/core/Tooltip';
import { VirtTable } from 'components';
import { DialogContext, ProductsContext } from 'contexts';
import config from '../../../config';

const columns = [
  {
    id: 'name',
    label: 'Short Product Name',
    sortable: true,
    xs: 3,
    style: {},
    headerStyle: { width: '25%' },
  },
  {
    id: 'long_name',
    label: 'Long Product Name',
    sortable: true,
    xs: 3,
    style: {},
    headerStyle: { width: '25%' },
  },
  { id: 'description', label: 'Description', sortable: true, xs: 3, style: {} },
  { id: 'actions', xs: 3, style: { margin: 'auto' }, headerStyle: { width: '25%' } },
];

const useStyles = makeStyles((theme) => ({
  editButtonsGroup: {
    display: 'flex',
  },
  componentVisibility: {
    display: '',
  },
}));

const ProductsTable = (props) => {
  const classes = useStyles();

  const targetRef = useRef();
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const { actions: dialogActions } = useContext(DialogContext);
  const { actions: productsActions } = useContext(ProductsContext);

  const removeProduct = (id) =>
    dialogActions.open({
      title: 'Remove Product',
      contentText: 'This product will be permanently removed. Are you sure?',
      acceptBtnText: 'Remove',
      rejectBtnText: 'Cancel',
      acceptBtnCallback: () => productsActions.removeProductById(id),
    });

  useLayoutEffect(() => {
    if (targetRef.current) {
      setDimensions({
        width: targetRef.current.offsetWidth,
        height: window.innerHeight - targetRef.current.offsetTop - 32,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetRef.current?.offsetWidth, targetRef.current?.offsetHeight]);

  const columnsShow = [...columns];

  if(false && props.products.filter(el => el.sku).length){
    columnsShow.splice(1,0,
      {
        id: 'sku',
        label: 'Product number',
        sortable: true,
        xs: 3,
        style: {},
        headerStyle: { width: '10%' },
      }
    );
  }



  const rows = props.products.map((product) => {
    return {
      ...product,
      actions: (
        <>
          <div className={classes.editButtonsGroup}>
            <Tooltip
              title="Edit / View"
              arrow
              placement="top"
              onClick={() => {
                if(product.sku) {
                  props.history.push(
                    `/products/${product.business_unit}/${product.category}/by-sku/${encodeURIComponent(
                      product.sku,
                    )}/edit`,
                  );
                } else {
                  props.history.push(
                    `/products/${product.business_unit}/${product.category}/${encodeURIComponent(
                      product.name,
                    )}/edit`,
                  );
                }
              }}
            >
              <IconButton aria-label="edit / view">
                <EditIcon />
              </IconButton>
            </Tooltip>
            {props.canEdit && (
              <Tooltip title="Delete" arrow placement="top">
                <IconButton aria-label="delete" onClick={() => removeProduct(product._id)}>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            )}
          </div>
          <div className={classes.editButtonsGroup}>
            {props.canEdit && (
              <Tooltip title="Duplicate" arrow>
                <IconButton
                  aria-label="duplicate"
                  onClick={() => {
                    //product.name= product.name + config.REACT_TEXT_DUPLICATE
                    product.isDuplicate = true;
                    const { _id, __v, createdAt, updatedAt, ...rest } = product;
                    props.history.push(
                      `/products/${product.business_unit}/${product.category}/new`,
                      rest,
                    );
                  }}
                >
                  <FileCopyIcon />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title="Datasheet" arrow className={classes.componentVisibility}>
              <span>
                <IconButton
                  aria-label="datasheet"
                  disabled={!product.template?.id}
                  onClick={() => {
                    window.open(
                      `${config.API_URL}products/${encodeURIComponent(product.name)}/pdf`,
                      '_blank',
                    );
                  }}
                >
                  <BorderAllIcon />
                </IconButton>
              </span>
            </Tooltip>
          </div>
        </>
      ),
    };
  });

  return (
    <div ref={targetRef}>
      <VirtTable
        columns={columnsShow}
        dimensions={dimensions}
        rows={rows}
        headerHeight={58}
        rowHeight={129}
        keyField={'_id'}
        defaultOrderBy="name"
      />
    </div>
  );
};

export default withRouter(ProductsTable);
